module.exports = __webpack_public_path__ + "img/riointbig6.3bd5650b.png";